import React, { useState, useContext, useEffect } from "react";
import styled from "styled-components";
import { MiniStoreThemeContext } from "../../../MiniStoreContexts/MiniStoreThemeContext";
import { useLocation, useNavigate } from "react-router-dom";
import { FaChevronLeft } from "react-icons/fa";

const GeneralTabs = () => {
  const { theme } = useContext(MiniStoreThemeContext);
  const [activeTab, setActiveTab] = useState("home"); // Default active tab
  const navigate = useNavigate();
  const location = useLocation();
  // console.log("location", location.pathname.split("/").length);
  const handleTabClick = (tab) => {
    setActiveTab(tab);
    navigate(tab === "home" ? "/mini-store/home" : "/mini-store/shop");
  };
  const isSubRoute = location.pathname.split("/").length > 3;
  useEffect(() => {
    if (location.pathname.startsWith("/mini-store/home")) {
      setActiveTab("home");
    } else if (location.pathname.startsWith("/mini-store/shop")) {
      setActiveTab("shop");
    }
  }, [location.pathname]);

  return (
    <div className="d-flex flex-column justify-content-center align-items-center">
      <StyledLine theme={theme} />
      <TabsWrapper>
        <TabButton
          theme={theme}
          isActive={activeTab === "home"}
          onClick={() => handleTabClick("home")}
        >
          {isSubRoute && activeTab === "home" && <FaChevronLeft />}
          <span>Home</span>
        </TabButton>
        <TabButton
          theme={theme}
          isActive={activeTab === "shop"}
          onClick={() => handleTabClick("shop")}
        >
          {isSubRoute && activeTab === "shop" && <FaChevronLeft />}
          <span>Shop</span>
        </TabButton>
      </TabsWrapper>
    </div>
  );
};

export default GeneralTabs;

// Styled Components
const TabsWrapper = styled.div`
  display: flex;
  gap: 12px;
  margin: 20px 0;
`;

const TabButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 110px;
  gap: 6px;
  flex: 1;
  padding: 12px 20px;
  border: none;
  border-radius: 0.15rem;
  font-size: 18px;
  font-weight: 500;
  font-family: "Outfit", sans-serif;
  cursor: pointer;
  transition: background-color 0.3s ease;

  background-color: ${({ theme, isActive }) =>
    isActive ? theme.primaryColor.primary : theme.primaryColor.secondary};
  color: ${({ isActive, theme }) =>
    isActive ? theme.textColor.primary : theme.textColor.secondary};

  &:hover {
    opacity: 0.9;
  }
`;

const StyledLine = styled.div`
  width: 223px;
  height: 5px;
  background-color: ${({ theme }) => theme.primaryColor.primary};
  box-shadow: ${({ theme }) => theme.boxShadow?.secondary};
  border-radius: 0.5rem;
`;

const BreadcrumbWrapper = styled.div`
  margin-top: 20px;
  font-size: 16px;
  color: ${({ theme }) => theme.textColor.primary};
`;
